import type { ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  subtitle?: ReactNode;
  cta?: ReactNode;
}

/**
 * Resend-style empty surface: icon glyph + headline + sub + CTA. Per
 * docs/07 §21.1 pecado #4, never ship "No data" — always give the owner a
 * next step.
 */
export function EmptyState({ icon: Icon, title, subtitle, cta }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed p-12 text-center">
      <div className="rounded-full bg-muted p-3">
        <Icon className="h-6 w-6 text-muted-foreground" aria-hidden="true" />
      </div>
      <h3 className="text-base font-medium">{title}</h3>
      {subtitle ? <p className="max-w-sm text-sm text-muted-foreground">{subtitle}</p> : null}
      {cta ? <div className="mt-2">{cta}</div> : null}
    </div>
  );
}
